module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "next"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/1.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Book-Title_SubHeading"
  }, [_vm._v("Essential Elixirs")]), _vm._v(" "), _c('p', {
    staticClass: "Book-Title_SubHeading"
  }, [_vm._v("for the Mind, Body, ")]), _vm._v(" "), _c('p', {
    staticClass: "Book-Title_SubHeading"
  }, [_vm._v("and Spirit")]), _vm._v(" "), _c('p', {
    staticClass: "Book-Title_SubHeading"
  }), _vm._v(" "), _c('p', {
    staticClass: "Book-Title_SubHeading"
  }), _vm._v(" "), _c('p', {
    staticClass: "Book-Title_Author"
  }, [_vm._v("Elise Marie Collins")]), _vm._v(" "), _c('p', {
    staticClass: "pictures_Conari-Logo"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/cplogo_titlepage.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Book-Title_Coral-Gables _idGenParaOverride-1"
  }, [_vm._v("Coral "), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("Gables, FL")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-54d1504e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ChakraTonicsebk1.vue
// module id = 63
// module chunks = 0